// src\themes\lino\components\ProductCategoryView.tsx
import SliderSection from "@/components/main/products/SliderSection";
import Container from "@/components/shared/Container";
import { Suspense } from "react";
import CategoryNavSection from "./CategoryNavSection";
import { ProductsListSkeleton } from "@/components/skeleton/ProductListSkeleton";
import ProductsList from "./ProductsList";
import { BannerSliderSkeleton } from "@/components/skeleton/BannerSliderSkeleton";

interface ProductViewProps {
    slug: string;
    query: {
        page?: string;
        is_available?: number;
        perPage?: string;
        search?: string;
        tag?: string;
        sort_by: string;
    }
}
export default function ProductCategoryView({ slug, query }: ProductViewProps) {

    const decodedSlug = decodeURIComponent(slug || 'all');
    const page = Number(query?.page) || 1;
    const is_available = Number(query?.is_available);
    const perPage = Number(query?.perPage) || 16;
    const search = query?.search as string
    const tag = query?.tag as string
    const sort_by = query?.sort_by as string

    return (
        <div>
            <Suspense fallback={<BannerSliderSkeleton varient="short" />}>
                <SliderSection slug={decodedSlug} />
            </Suspense>
            <Container className="mt-16">
                <CategoryNavSection activeSlug={decodedSlug} />
                <Suspense fallback={<ProductsListSkeleton perPage={perPage} />}>
                    <ProductsList slug={decodedSlug} page={page} perPage={perPage} search={search} tag={tag} sort_by={sort_by} is_available={is_available} />
                </Suspense>
            </Container>
        </div>
    )
}